import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router";
import App from './App';
import Home from './pages/Home';
import reportWebVitals from './reportWebVitals';
import CreatorPage from './pages/CreatorPage';
import UserProfilePage from './pages/UserProfilePage';
import FullView from 'pages/FullView';
import EventDetails from 'pages/EventDetails';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      {/* App como layout con Outlet */}
      <Route path="/" element={<App />}>
        {/* Rutas hijas que se renderizan dentro del Outlet */}
        <Route index element={<Home />} />
        <Route path="creators/:nickname" element={<CreatorPage/>} />
        <Route path="users/:username" element={<UserProfilePage/>} />
        <Route path="publication/:publicationID" element={<FullView/>} />
        <Route path="events/:eventID" element={<EventDetails/>} />
      </Route>
    </Routes>
  </BrowserRouter>
);

reportWebVitals();